import React, { useEffect, useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginStart } from "../../../redux/slice/authSlice";
import { Routers } from "../../../routes/Constant";
import "./ConfirmDetails.css";

const ConfirmDetailLogin = ({
  formHandler,
  SelectPacknext,
  updateFieldData,
  bookingData,
}) => {
  const [errorLoginMessage, setErrorLoginMessage] = useState("");
  const { user, error, message } = useSelector((state) => state?.auth);
  const { learnerDashboardProfileInfo } = useSelector((state) => state.auth);
  const schema = yup.object().shape({
    email: yup
      .string()
      .required("Email is required")
      .email("Enter a valid email"),
    password: yup.string().min(6, "Password must be at least 6 characters"),
  });

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (values) => {
    try {
      await dispatch(loginStart(values));
    
    } catch (error) {
      console.error("An error occurred while logging in:", error);
      setErrorLoginMessage("Invalid email or password. Please try again.");
    }
  };




  useEffect(() => {
    const fetchDashboardInfo = async () => {
      try {
        localStorage.setItem("token", user?.data?.data.token);
        updateFieldData("learner_id", user?.data?.data?.id);
      
        SelectPacknext();
      } catch (error) {
        console.error(
          "An error occurred while fetching dashboard info:",
          error
        );
       
      }
    };



    if (user?.data?.data) {
      fetchDashboardInfo();
    }
  }, [user]);




  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col>
            <div>
              <input
                type="email"
                className="input_tag br-10 p-2 p-md-4"
                {...register("email")}
                placeholder="Email*"
              />
              {errors.email && (
                <div className="text-danger m-1">{errors.email.message}</div>
              )}
            </div>
            <div className="pt-2 pt-md-4">
              <input
                type="password"
                placeholder="Password*"
                className="input_tag br-10 p-2 p-md-4"
                {...register("password")}
              />
              {errors.password && (
                <div className="text-danger m-1">{errors.password.message}</div>
              )}
            </div>

            {errorLoginMessage && (
              <p className="text-danger">{errorLoginMessage}</p>
            )}
          </Col>
        </Row>
        <div className="bottom-wrapper">
          <div className="btn-wrapper-confirmDetail">
            <Button variant="primary" type="submit">
              Login
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                formHandler(true);
              }}
            >
              Didn’t have an account?
            </Button>
          </div>
          <div className="link-wrapper">
            <Link
              to={Routers.ForgotPasword}
              className="text-indigo text-decoration-none"
            >
              Forgot password?
            </Link>
          </div>
        </div>
      </form>
    </>
  );
};

export default ConfirmDetailLogin;
